import { ReactNode } from "react";
import { FieldValues, FormProvider, UseFormReturn } from "react-hook-form";

interface FormProps<TFieldValues extends FieldValues, TContext>
  extends UseFormReturn<TFieldValues, TContext>{
  className?: string;
  onSubmit: (data: TFieldValues) => void;
  children: ReactNode | ReactNode[];
  /** Pass "off" on search/lookup forms to prevent password-manager DOM injection */
  autoComplete?: string;
}

export const Form = <TFieldValues extends FieldValues, TContext>({
  className,
  handleSubmit,
  onSubmit,
  children,
  autoComplete,
  ...rest
}: FormProps<TFieldValues, TContext>) => {
  return (
    <FormProvider handleSubmit={handleSubmit} {...rest}>
      <form className={className} onSubmit={handleSubmit(onSubmit)} autoComplete={autoComplete}>
        {children}
      </form>
    </FormProvider>
  );
};
